import { GetServerSideProps } from 'next';
import { z } from 'zod';
import cms from '../lib/contentful';
import ResourceLibrary, { ResourceLibraryProps } from '../src/components/ResourceLibrary';
import { RESOURCE_LIBRARY_PAGINATION_PAGE_SIZE } from '../src/Config';

export const resourcesQuerySchema = z.object({
  q: z.string().default(''),
  count: z.coerce.number().transform(async (val) => (val > 0 ? val : (await cms.getResourceCounts([], '')).total))
    .default(RESOURCE_LIBRARY_PAGINATION_PAGE_SIZE),
  type: z.array(
    z.string(),
  ).or(z.string())
    .transform((val) => (
      (Array.isArray(val) ? val : [val]).filter(Boolean))).default([]),
  page: z.coerce.number().default(1),
});

export const getServerSideProps: GetServerSideProps<
ResourceLibraryProps> = async (ctx) => {
  const {
    count, page, type: types, q: query,
  } = await resourcesQuerySchema.parseAsync(ctx.query);
  const { total: resourceCount, typeCounts } = await cms.getResourceCounts(types, query);
  const resources = await cms.getResourceLibraryItems(
    page - 1,
    count,
    types,
    query,
  );

  const resourceLibraryProps = await cms.getResourceLibraryPage();

  const pageCount = Math.ceil(resourceCount / count);
  const navbarData = await cms.getNavbar();

  return {
    props: {
      pageCount,
      resourceLibraryProps,
      currentPage: page,
      navbarData: navbarData.menu,
      currentResources: resources,
      query: ctx.query,
      filterProps: {
        selectedTypes: types,
        resourceCount,
        query,
        typeCounts,
        perPage: count,
      },
    },
  };
};

export default ResourceLibrary;
